import { selectWarehouses, selectWarehouseStatus } from 'containers/Warehouses/warehousesSlice'
import { addNotification } from 'containers/Notifications/notificationsSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import useTranslation from 'hooks/useTranslation'
import React, { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import Loading from 'components/Loading'

interface KeyCabinetUniversalProps {
  purpose?: warehouse.WarehouseActionKeyCabinetGrantPurpose
}

const KeyCabinetUniversal: React.FC<KeyCabinetUniversalProps> = ({ purpose }) => {
  const warehouses = useReduxSelector(selectWarehouses)
  const status = useReduxSelector(selectWarehouseStatus)

  const { replace } = useHistory()
  const dispatch = useReduxDispatch()
  const { t } = useTranslation('keyCabinet')
  const actions = useRef({ replace, dispatch, t })
  actions.current.dispatch = dispatch
  actions.current.replace = replace
  actions.current.t = t

  useEffect(() => {
    if (status === 'succeed') {
      const warehouseWithAccessToKeyCabinet = warehouses.find(w => w.actions?.key_cabinet && (purpose ? w.actions?.key_cabinet?.grant?.purpose === purpose : true))
      if (warehouseWithAccessToKeyCabinet) {
        actions.current.replace(`/warehouses/${warehouseWithAccessToKeyCabinet.objectId}/keycabinet`)
      } else {
        actions.current.dispatch(addNotification({
          type: 'danger',
          message: actions.current.t(purpose === 'return' ? 'youDontHaveAKeyToReturn' : 'youDontHaveAKeyToPickUp')
        }))
        actions.current.replace('/warehouses')
      }
    }
  }, [status, purpose, warehouses])

  return (
    <Loading />
  )
}

export default KeyCabinetUniversal